export default "__VITE_ASSET__DuKhSy_p__"